import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=7fdcc13f&scoped=true&"
import script from "./ChatForm.vue?vue&type=script&lang=js&"
export * from "./ChatForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=7fdcc13f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdcc13f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdcc13f')) {
      api.createRecord('7fdcc13f', component.options)
    } else {
      api.reload('7fdcc13f', component.options)
    }
    module.hot.accept("./ChatForm.vue?vue&type=template&id=7fdcc13f&scoped=true&", function () {
      api.rerender('7fdcc13f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/ChatForm.vue"
export default component.exports